export const EVENTS = {
  AsSeenOnInstagramImpression: 'As Seen on Instagram Impression',
  AsSeenOnInstagramClicked: 'As Seen On Instagram Clicked',
  SocialMediaLinkClicked: 'Social Media Link Clicked',
  CurrentBidsCarouselImpression: 'Current Bids Carousel Impression',
  CurrentAsksCarouselImpression: 'Current Asks Carousel Impression',
  MerchandisingModuleImpression: 'Merchandising Module Impression',
  MerchandisingModuleClick: 'Merchandising Module Click',
  ValuePropsImpression: 'Value Props Impression',
  SeeMyAccountClicked: 'See My Account Clicked',
  HomeBannerClicked: 'Home Banner Tapped',
  HomeBannerViewed: 'Home Banner Viewed',
  HomepageImpression: 'Homepage Impression',
  BannerCollageClicked: 'Banner Collage Clicked',
  BannerCollageItemImpression: 'Banner Collage Item Impression',
  RecentlyViewedImpression: 'Recently Viewed Impression',
  RecentlyViewedCarouselImpression: 'Recently Viewed Carousel Impression',
  ProductCarouselArrowClicked: 'Product Carousel Arrow Clicked',
  PDPRecentlyViewedImpression: 'Product Page Recently Viewed Impression',
  PDPBelowRetailBadgeImpression: 'Product Page Below Retail Badge Impression',
  PDPAnonymousRecentlyViewedImpression:
    'Product Page Anonymous Recently Viewed Impression',
  PDPValuePropImpression: 'Value Prop Impression',
  BrowseRecentlyViewedImpression: 'Browse Page Recently Viewed Impression',
  BottomOfPDPImpression: 'Bottom of PDP Impression',
  SignUp: 'Sign up',
  Registered: 'Registered',
  Login: 'Login',
  LoggedIn: 'Logged In',
  BannerCarouselClicked: 'Banner Carousel Clicked',
  BannerCarouselItemImpression: 'Banner Carousel Item Impression',
  BrowseAll: 'Browse All',
  BidNew: 'Bid New',
  BidNewComplete: 'Bid New Complete',
  BidEdit: 'Bid Edit',
  BidSuccess: 'Bid Successfully Posted',
  BuyerBought: 'Buyer Bought',
  NewBuyerBought: 'New Buyer Bought',
  RepeatBuyerBought: 'Repeat Buyer Bought',
  AskNew: 'Ask New',
  AskEdit: 'Ask Edit',
  AskComplete: 'Ask Complete',
  SellerSold: 'Seller Sold',
  NewSellerSold: 'New Seller Sold',
  RepeatSellerSold: 'Repeat Seller Sold',
  CollectionAddSneaker: 'Portfolio Trigger Click',
  FollowAddSneaker: 'Follow Trigger Click',
  SearchSelectedItem: 'Search Selected Item',
  SearchSelectedVertical: 'Search Selected Vertical',
  NavSellClick: 'Nav Sell Clicked',
  WaleBanner: 'Wale Banner Click',
  TwitterShare: 'Twitter Share Click',
  FacebookShare: 'Facebook Share Click',
  PinterestShare: 'Pinterest Share Click',
  EmailShare: 'Email Share Click',
  RelatedProduct: 'Related Product Click',
  RiskifiedRecoverPopUp: 'Riskified Recover Pop Up',
  EmailSignup: 'Email Signup Successful',
  EmailSignupDismissed: 'Email Signup Dismissed with no action',
  SearchTileClick: 'Search Result Tile Click',
  HighBidTileClick: 'Recent Highest Bids Product Click',
  LowAskTileClick: 'Recent Lowest Asks Product Click',
  MakeAnOfferClick: 'Make An Offer Click',
  MakeAnOfferImpression: 'Make An Offer',
  MostPopularTileClick: 'Most Popular Product Click',
  MarketMoveTileClick: 'Market Movers Product Click',
  RecommendedProductTileClick: 'Recommended Product Click',
  ReleaseCalendarClick: 'Release Calendar Tile Click',
  UniversalFreeShipClick: 'Univsersal Site Free Shipping Banner Click',
  FollowProduct: 'Follow a product',
  UnfollowProduct: 'Unfollow a product',
  ProductPage: 'Product Page View',
  ProductPageGeneric: 'Product Page View - Generic',
  ProductPageVariant: 'Product Page View - Specific Variant',
  ProductPageLandingFromTraffc: 'Product Page Landing from Traffic Impression',
  BrowsePage: 'Browse Page View',
  HomePage: 'Home Page View',
  DLPPage: 'DLP Page View',
  DLPSeeProductDetails: 'DLP See Product Details Tapped',
  DLPDiscoverMore: 'DLP Discover More Tapped',
  browsePageBannerClick: 'Browse Page Promo Banner Click',
  ModalClick: 'Hardgate Activity Modal Click',
  ModalSignupClick: 'Hardgate Activity Modal Signup Click',
  ModalLoginClick: 'Hardgate Activity Modal Login Click',
  SalesTableSignupClick: 'Hardgate All Sales Signup Click',
  SalesTableLoginClick: 'Hardgate All Sales Login Click',
  handbagModalClick: 'Handbag Signup Modal Click',
  handbagModalDismiss: 'Handbag Signup Modal Dismiss',
  handbagModalView: 'Handbag Signup Modal View',
  watchModalClick: 'Watch Signup Modal Click',
  watchModalDismiss: 'Watch Signup Modal Dismiss',
  watchModalView: 'Watch Signup Modal View',
  brandTileClicked: 'Brand Tile Clicked',
  UploadImageClick: 'Upload Image Button Clicked',
  UploadImageScreenView: 'Upload Image Screen Veiwed',
  UploadImageSubmitClick: 'Upload Image Submit Clicked',
  UploadImageStatus: 'Upload Image Status',
  SizeDropdownClick: 'Size Selector Opened',
  SizeChartClick: 'Size Chart Clicked',
  multiAskClicked: 'Sell Items Button Tapped',
  multiAskConfirmed: 'Confim Asks Button Tapped',
  basSortClick: 'BAS Sort Click',
  basCellClick: 'BAS Cell Click',
  basUpdateAsk: 'Update Ask Click from BAS Cell Click',
  AffirmComplete: 'Affirm - Complete',
  AffirmCancel: 'Affirm - Cancel',
  AffirmFail: 'Affirm - Fail',
  belowRetailClick: 'Below Retail Clicked',
  productTileClick: 'Product Tile Clicked',
  multiEditForm: 'Multi Edit Form',
  multiEditComplete: 'Multi Edit Complete',
  multiEditConfirm: 'Multi Edit Confirm',
  confirm: 'Confirm',
  lithiumErrorScreenView: 'Lithium Ion Battery Error Screen View',
  mobileNavOpenedClick: 'Mobile Nav Opened Click',
  mobileNavPrimaryButtonClick: 'Mobile Nav Primary Button Click',
  mobileNavSecondaryButtonClick: 'Mobile Nav Secondary Button Click',
  sellerCurrentReport: 'Selling History Export',
  sellerPendingReport: 'Selling Pending Export',
  belowRetailProductTileClick: 'Below Retail Product Tile Click',
  ShowRecommendedOnHomepage: 'Recommended For You Tile Click',
  RecentlyViewedTileClick: 'Recently Viewed Tile Click',
  TileCollectionClicked: 'Tile Collection Clicked',
  BrowseRecentlyViewedTileClick: 'Browse Page Recently Viewed Tile Click',
  ViewBox: 'View Box',
  PrintLabel: 'Print label Clicked',
  SaveAndPrintNow: 'Save & Print Now',
  Save: 'Save',
  EditShipmentClick: 'Edit Clicked',
  EditShipmentConfirm: 'Edit Confirm',
  DeleteBoxConfirm: 'Delete Box Confirm',
  StarNewBox: 'Start a New Box',
  ShipXItems: 'Ship X Items',
  BulkShippingCTADisplayed: 'Bulk Shipping CTA displayed',
  SellingTabClicked: 'Selling Tab Clicked',
  SortClicked: 'Sort Clicked',
  SellingSearch: 'Selling Search Executed',
  DeleteAskClicked: 'Delete Ask Clicked',
  EditAskClicked: 'Edit Ask Clicked',
  PopoutClicked: 'Pop Out Clicked',
  MultiEditClicked: 'Multi-Edit Clicked',
  MultiAskClicked: 'Multi-Ask Clicked',
  SellingExportRequest: 'Export Report Clicked',
  ExtendAllAsksClicked: 'Extend All Asks Clicked',
  SellingTrackClicked: 'Track Item Clicked',
  SellingOrderDetailsCurrent: 'Order Details - Selling Current Item Tapped',
  SellingOrderDetailsPending: 'Order Details - Selling Pending Item Tapped',
  SellingOrderDetailsHistory: 'Order Details - Selling History Item Tapped',
  BuyingOrderDetailsPending: 'Order Details - Buying Pending Item Tapped',
  BuyingOrderDetailsHistory: 'Order Details - Buying History Item Tapped',
  BuyingOrderDetailsCurrent: 'Order Details - Buying Current Item Tapped',
  UpdatedAsk: 'Updated Ask',
  UpdatedBid: 'Updated Bid',
  AffirmBuyNowTappedPDP: 'Affirm Buy Now Tapped - PDP',
  AffirmInfoTappedPDP: 'Affirm Info Tapped - PDP',
  PlaceBidBillingStep: 'Place Bid Billing Step',
  BuyNowBillingStep: 'Buy Now Billing Step',
  EnterBidFieldClick: 'Enter Bid Field Click',
  EnterAskFieldClick: 'Enter Ask Field Click',
  CheckoutFlowCancelClick: 'Checkout Flow Exit - Cancel Click',
  CheckoutFlowExitStockXClick: 'Checkout Flow Exit - StockX Click',
  FAQBidClick: 'FAQ Bid Click',
  FAQAskClick: 'FAQ Ask Click',
  AddBillingInfoRowClick: 'Add Billing Info Row Click',
  EditExistingBillingInfoRowClick: 'Edit Existing Billing Info Row Click',
  BuyNowAmountFieldClick: 'Buy Now Amount Field Click',
  SellNowAmountFieldClick: 'Sell Now Amount Field Click',
  AddShippingAddressRowClick: 'Add Shipping Address Row Click',
  EditShippingAddressRowClick: 'Edit Shipping Address Row Click',
  RedemptionPaymentMethodButtonClick: 'Edit Existing Billing Info Row Click',
  RedemptionPaymentMethodPageImpression:
    'Payment Method selection page Impression',
  RedeemButtonClick: 'Redeem Button Clicked',
  ConfirmRedeemButtonClick: 'Confirm Redeem button clicked',
  ReturnToPortfolioButtonClick: 'Return to Portfolio button clicked',
  SizeSelectedClick: 'Size Selected Click',
  SizeOptionClicked: 'Size Option Clicked',
  SizeFormatClicked: 'Size Format Clicked',
  UnauthenticatedNextBtnClick: 'Unauthenticated Next Button Click',
  ChangeCurrentlySelectedSizeClick: 'Change Currently Selected Size Click',
  SizeChartBackClick: 'Size Chart Back Click',
  SizeChartBackButtonClicked: 'Size Chart Back Button Clicked',
  SizeChartSizeFormatToggleClicked: 'Size Chart Size Format Toggle Clicked',
  SizeChartSizeFormatOptionClicked: 'Size Chart Size Format Option Clicked',
  ProcessingFeeTooltipClick: 'Processing Fee Tooltip Click',
  AffirmPrequalifyNowClick: 'Affirm Prequalify Now Click',
  PayLaterMessagingCheckoutClick: 'PayPal Learn More Tapped',
  PaypalMessageShownCheckout: 'PayPal BNPL Shown',
  PaypalPayLaterWindowClosed: 'Close PayPal BNPL',
  PaypalPayLaterError: 'PayPal BNPL Error',
  PayoutInfoOnNextButtonClick: 'Payout Info On Next Button Click',
  ExpirationDropdownClick: 'Expiration Dropdown Click',
  CancelAddingPaymentMethod: 'Cancel Adding Payment Method',
  PaymentMethodClicked: 'Payment Method Clicked',
  CheckoutBadgeClicked: 'Checkout Badge Clicked',
  HotCollectiblesTileClick: 'Hot Collectibles Tile Click',
  TrendingStreetwearTileClick: 'Trending Streetwear Tile Click',
  EnteredSearchQuery: 'Entered Search Query',
  NoSearchResults: 'No Search Results',
  ThreeDSecureChallengeAttempted: '3DS Challenge Attempted',
  ThreeDSecureChallengeResponse: '3DS Challenge Response',
  ThreeDSecureAuthenticationRequired: '3DS Authentication Required',
  SellerProfileClicked: 'Seller Profile Tapped',
  SellerProfileFAQClicked: 'Learn More Tapped',
  PDPBuyNowPayLaterBuyNowTapped: 'PayPal Buy Now Pay Later Buy Now Tapped',
  PDPBuyNowPayLaterLearnMoreTapped:
    'PayPal Buy Now Pay Later Learn More Tapped',
  PDPBuyNowPayLaterImpression: 'PayPal Buy Now Pay Later Callout Impression',
  PDPViewAllSalesClick: 'View All Sales Click',
  PDPExpandProductDescriptionClick: 'Expand Product Description Clicked',
  PDPTraitsShowMore: 'Show More Tapped',
  PDPTraitsShowLess: 'Show Less Tapped',
  PDP360ProductImageRotated: '360 Product Image Rotated',
  ProductPhotoZoomIconClick: 'Product Photo Zoom Icon Click',
  ProductPhotoClick: 'Product Photo Click',
  ProductZoomModalDismissed: 'Zoom Modal Dismissed',
  ProductZoomModalZoomIn: 'Zoom Modal Zoomed In',
  ProductZoomModalZoomOut: 'Zoom Modal Zoomed Out',
  ProductZoomModalProductImagePanned: 'Zoom Modal Product Image Panned',
  ProductZoomModalImpression: 'Zoom Modal Impression',
  PDPCarouselEndCapTileClicked: 'Carousel End Cap Tile Clicked',
  PDP12MonthHistoricalEndCapArrowClicked:
    '12 Month Historical End Cap Arrow Clicked',
  CanadaDisclaimerEligibility: 'Canada Disclaimer Eligibility',
  SuggestedAddressError: 'Suggested Address Error',
  UseSuggestedAddressClick: 'Use Suggested Address',
  UseSuggestedAddressCancelClick: 'Cancel Suggested Address',
  BackToEditButtonClicked: 'Back to Edit button clicked',
  AddressCheckboxSelected: 'Address checkbox selected',
  UseEnteredAddress: 'Use entered address',
  ProceedWithEnteredAddressButtonClicked:
    'Proceed with entered address button clicked',
  AddressValidationError: 'Address Validation Error',
  SuggestedAddressValidationError: 'Suggested Address Validation Error',
  PDPDateRangeSelected: 'Date Range Selected',
  CheckoutError: 'FE Error',
  RiskifiedClickHereErrorDisplayed: 'Riskified Click Here Error',
  RiskifiedClickHereInteraction: 'Riskified Click Here',
  CardVerificationError: 'Card Verification Error',
  ProductPageLowInventoryImpression: 'Product Page Low Inventory Impression',
  ChatClick: 'Chat Click',
  VerticalPickerClicked: 'Vertical Picker Clicked',
  DiscountCodeEntryClick: 'Discount Code Entry Click',
  TotalPayoutClick: 'Total Payout Clicked',
  CloseTotalPayoutClick: 'Close Total Payout Clicked',
  BuyProcessingFeeImpression: 'Buy Processing Fee Impression',
  CitconEligibility: 'Citcon Eligibility',
  ChangePaymentMethod: 'Change Payment Method',
  CitconQRCode: 'Citcon QR Code',
  CancelCitconQRCode: 'Cancel Citcon QR Code',
  PriceGuidanceTooltipClick: 'Sell Faster Tooltip Click',
  PriceGuidanceImpression: 'Sell Faster Guidance Displayed',
  PriceGuidanceRetailPriceShown: 'Retail Price Shown',
  BFGetMyPrizeButtonClick: 'BF Get my Prize Button Click',
  AlgoliaSearchIndex: 'Algolia Search Index',
  ProductPageBuySellButtonsVariantImpression:
    'Product Page Buy Sell Buttons Variant Impression',
  BrowseSuggestionClick: 'Browse Suggestion Clicked',
  CheckoutBadgeImpression: 'Badging',
  ProductPageSellingFastBadgeImpression:
    'Product Page Selling Fast Badge Impression',
  ProductPagePriceDropBadgeImpression:
    'Product Page Price Drop Badge Impression',
  InboxIconClicked: 'Inbox Icon Clicked',
  InboxMessageClicked: 'Inbox Message Clicked',
  InboxTooltipImpression: 'Inbox Tooltip Impression',
  InboxTooltipDismissed: 'Inbox Tooltip Dismissed',
  CheckoutCrossBuyingImpression: 'Checkout Cross Buying Buttons Impression',
  CheckoutCrossBuyingVaultClick: 'Checkout Cross Buying NFT Toggle Clicked',
  CheckoutCrossBuyingShipClick:
    'Checkout Cross Buying Physical Address Toggle Clicked',
  CheckoutCrossBuyingTooltipInteract:
    'Checkout Cross Buying Tooltip Hover/Click',
  EuReturnHereLinkDisplayed: 'EU Return here link displayed',
  EuReturnHereLinkClicked: 'EU Return here link clicked',
  SettingsPageEditBillingClick: 'Edit Billing Button Clicked',
  SettingsPageEditShippingClick: 'Edit Shipping Button Clicked',
  BidAmountEntryShipping: 'Place Bid Shipping Step',
  BuyAmountEntryShipping: 'Buy Now Shipping Step',
  DynamicAddressFormImpression: 'Dynamic Shipping Address Form Impression',
  StaticAddressFormImpression: 'Static Shipping Address Form Impression',
  SubmitShippingForm: 'Save Shipping Click',
  SubmitBillingForm: 'Save Billing Click',
  StaticAddressFormError: 'Static Address Form Error',
  DynamicAddressGenericError: 'Dynamic Address Generic Error',
  DynamicAddressInlineError: 'Dynamic Address Inline Error',
  DynamicAddressNetworkError: 'Dynamic Address Network Error',
  CHK_SP_BillingError: 'Payment / Billing Address Validation error',
  PortfolioTabClicked: 'Portfolio Tab Clicked',
  PortfolioPageLoaded: 'Portfolio Page Loaded',
  HTML_SITEMAP_POPULAR_PRODUCTS_VIEWED: 'HTML Sitemap Popular Products Viewed',
  HTML_SITEMAP_POPULAR_SEARCH_VIEWED: 'HTML Sitemap Popular Search Viewed',
  HTML_SITEMAP_POPULAR_BRANDS_VIEWED: 'HTML Sitemap Popular Brands Viewed',
  HTML_SITEMAP_LINK_CLICKED: 'HTML Sitemap Link Clicked',
  ExpandHardgateActivityModalDisclaimerLabelClick:
    'Expand Hardgate Activity Modal Disclaimer Label Click',
  CollapseHardgateActivityModalDisclaimerLabelClick:
    'Collapse Hardgate Activity Modal Disclaimer Label Click',
  QuerySuggestions: 'Query Suggestions',
  ShopByCategoryTileClicked: 'Shop By Category Tile Clicked',
  BidGuidanceAllInAsk: 'AIA Bid Guidance',
  BidGuidanceAllInAskTooltipOpen: 'AIA Bid Guidance Tooltip Tapped',
  BidGuidanceAllInAskLearnMoreClick: 'AIA Bid Guidance Learn More Click',
  CHK_Optimized_Next_CTA: 'CTA Optimization',
  EarnMoreClick: 'Earn More Clicked',
  SellFasterClick: 'Sell Faster Clicked',
  SellNowClick: 'Sell Now Clicked',
  PricingGuidanceTooltipClick: 'Pricing Guidance Tooltip Clicked',
  PricingGuidanceLearnMoreClick: 'Pricing Guidance Learn More Clicked',
  PricingGuidanceShown: 'Pricing Guidance Shown',
  RetailPriceShown: 'Retail Price Shown',
  NoGuidanceShown: 'No Guidance Shown',
  PricingGuidanceFailed: 'Pricing Guidance Failed',
  LocationModalDisplayed: 'Choose Your Location Modal Shown',
  LocationModalSettingsUpdated: 'Choose Your Location Modal | Settings Updated',
  LocationModalDismissed: 'Choose Your Location Modal Dismissed',
  LocationBannerDisplayed: 'Choose Your Location Banner Shown',
  LocationBannerSettingsUpdated:
    'Choose Your Location Banner | Settings Updated',
  LocationBannerDismissed: 'Choose Your Location Banner Dismissed',
  swipeInUserGeneratedContentModal: 'Swipe in User Generated Content Modal',
  UpdateBidView: 'Update Bid View',
  UpdateBid: 'Update Bid',
  BuyNow: 'Buy Now',
  LastSaleDisclaimerButtonClicked: 'Last Sale Disclaimer Button Clicked',
  PriceHistoryDisclaimerButtonClicked:
    'Price History Disclaimer Button Clicked',
  TwelveMonthHistoricalDisclaimerButtonClicked:
    '12 Month Historical Disclaimer Button Clicked',
  AsteriskViewed: 'Asterisk Viewed',
  OfferMessagesImpression: 'Offer Messages Impression',
  HamburgerMenuOpened: 'Hamburger Menu Opened',
};

export const FUNNEL_EVENTS = {
  bidBuyButtonClick: 'Buy or Bid Button Click',
  newCheckoutEntry: 'New Checkout Flow Entry',
  toggleBid: 'Bid/Buy Form Toggle Bid',
  toggleBuy: 'Bid/Buy Form Toggle Buy Now',
  placeBidForm: 'Place Bid Click (Form)',
  buyNowForm: 'Buy Now Click (Form)',
  confirmBidSummary: 'Confirm Bid Click (Summary)',
  confirmPurchaseSummary: 'Confirm Purchase Click (Summary)',
  askSellButtonClick: 'Sell or Ask Button Click',
  askHowItWorks: 'Ask How It Works Understand Click',
  askHowItWorksCancel: 'Cancel Ask How It Works Click',
  toggleAsk: 'Ask/Sell Form Toggle Ask',
  toggleSell: 'Ask/Sell Form Toggle Sell Now',
  placeAskForm: 'Place Ask Click (Form)',
  sellNowForm: 'Sell Now Click (Form)',
  reviewUpdatedAsk: 'Review Updated Ask',
  confirmUpdatedAsk: 'Confirm Updated Ask',
  updatedAsk: 'Updated Ask',
  askComplete: 'Ask Completed',
  confirmAskSummary: 'Confirm Ask Click (Summary)',
  confirmSaleSummary: 'Confirm Sale Click (Summary)',
};
